// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Caption} from 'sail/Text';
import type {Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';

type GatesListProps = {|
  article: Article,
|};

export const TranslationUtilsSection = ({article}: GatesListProps) => {
  if (!article.xray || !article.xray.conditions) {
    console.warn('Missing necessary x-ray data. Please contact #docs-product!'); // eslint-disable-line no-console
    return null;
  }

  const translationPercent = article.xray.translationPercent;

  let content = <Caption>Could not get translation percent</Caption>;
  if (translationPercent) {
    content = (
      <Caption>
        Translation Percent: {Math.round(translationPercent * 100)}
      </Caption>
    );
  }

  return (
    <XRaySidebarSection
      title="Translation Percents"
      hint="How much of this page has been translated and pulled"
    >
      <Group spacing={4}>{content}</Group>
    </XRaySidebarSection>
  );
};
